import { Location } from '@angular/common';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import {
  IonApp,
  IonContent,
  IonHeader,
  IonIcon,
  IonImg,
  IonLabel,
  IonList,
  IonMenu,
  IonRouterOutlet,
  IonSplitPane,
  IonToolbar,
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AuthService, CommunicationCoreService } from '@ubie/core';
import { addIcons } from 'ionicons';
import {
  add,
  addCircle,
  alertCircle,
  arrowBackOutline,
  checkmarkCircle,
  checkmarkOutline,
  chevronForwardOutline,
  closeCircle,
  closeOutline,
  cloudUpload,
  ellipse,
  grid,
  helpCircle,
  home,
  menu,
  person,
  personAdd,
  power,
  radioButtonOff,
  settings,
  settingsOutline,
} from 'ionicons/icons';

import { HeaderComponent } from './shared/header/header.component';
@Component({
  imports: [
    IonList,
    IonMenu,
    IonLabel,
    IonIcon,
    IonContent,
    IonSplitPane,
    IonApp,
    RouterModule,
    IonRouterOutlet,
    IonHeader,
    IonToolbar,
    IonImg,
    TranslatePipe,
    HeaderComponent,
  ],
  providers: [TranslateService, Location],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'installer-dashboard';

  readonly showOnlyRouterOutlet = signal(false);

  private readonly translateService = inject(TranslateService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private readonly destroyRef = inject(DestroyRef);
  private readonly communicationCoreService = inject(CommunicationCoreService);

  constructor() {
    addIcons({
      person,
      ellipse,
      home,
      grid,
      power,
      helpCircle,
      menu,
      closeCircle,
      checkmarkOutline,
      addCircle,
      personAdd,
      cloudUpload,
      alertCircle,
      add,
      arrowBackOutline,
      closeOutline,
      checkmarkCircle,
      chevronForwardOutline,
      radioButtonOff,
      settings,
      settingsOutline,
    });

    this.authService.getSavedUser();

    this.subscribeNavigationToCheckSideMenu();
    this.translateService.setFallbackLang('publicidb_1');
    this.translateService.use('publicidb_1');

    this.authService.autoLoginEvent.pipe(takeUntilDestroyed()).subscribe({
      next: () => {
        this.translateService.use(
          'admin_' + this.authService.getUserLanguageId(),
        );

        this.initMqttCommunication();
      },
    });
  }

  subscribeNavigationToCheckSideMenu(): void {
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        const path = this.location.path();
        if (
          path.indexOf('/login') > -1 ||
          path.indexOf('/forgot-password') > -1 ||
          path.indexOf('/activation') > -1 ||
          path.indexOf('/registration') > -1 ||
          path.indexOf('/reset-password') > -1
        ) {
          this.showOnlyRouterOutlet.set(true);
        } else {
          this.showOnlyRouterOutlet.set(false);
        }
      });
  }

  private async initMqttCommunication(): Promise<void> {
    // start mqtt communication
    await this.communicationCoreService.connectMqtt();
  }
}
